import { Location } from 'features/inventory/locations';
import { axiosPrivate } from 'shared/api';
import { BaseService } from 'shared/services/BaseService';

class PeriodicCostElementService extends BaseService<Location> {
  constructor() {
    super('periodic-cost-elements');
  }

  importFromFile = async (importFile: File, attachmentName = 'import_file') => {
    const res = await axiosPrivate.postForm(`${this.modulePrefix}/import-from-file/`, {
      [attachmentName]: importFile
    });
    return res.data;
  };
}

export const periodicCostElementService = new PeriodicCostElementService();
